import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {AppProvider} from '@app/providers';
import App from '@app/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@/styles/globals.scss';

ReactDOM.createRoot(document.getElementById('root')!).render(
    // <React.StrictMode>
        <BrowserRouter>
            <AppProvider>
                <App/>
            </AppProvider>
        </BrowserRouter>
    // </React.StrictMode>
);
